import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-664f50a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "timelapse"
}
const _hoisted_2 = {
  key: 1,
  class: "no_data"
}
const _hoisted_3 = { class: "no_data_text1" }
const _hoisted_4 = { class: "no_data_text2" }

import API from '@/js/const/api'
import http from '@/js/utils/http'
import Spinner from '@/components/atoms/Spinner'
import Thumbnail from '@/components/atoms/Thumbnail'
import { onUnmounted, ref } from 'vue'
import { CameraDetail } from '@/@types/typescript-axios'

type DisplaySizeType = {
  width: number
  height: number
}

type PropsType = {
  cameraDetail: CameraDetail
  displaySize: DisplaySizeType
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Live',
  props: {
    cameraDetail: null,
    displaySize: null
  },
  setup(__props: any) {

const props = __props as {
  cameraDetail: CameraDetail
  displaySize: DisplaySizeType
};

const apiPath = ref<string | null>(null)
const isLoaded = ref<boolean>(false)
const imgSrc = ref<string | null>(null)
const timer = ref<ReturnType<typeof setTimeout> | null>(null)
const requestError = ref<boolean>(false)
const isUnmounted = ref(false)



onUnmounted(() => {
  isUnmounted.value = true
  clearTimer()
})

const getLiveImg = async () => {
  clearTimer()
  if (isUnmounted.value) {
    return
  }
  try {
    isLoaded.value = false
    const res = await http.put(apiPath.value)
    // await 中にアンマウントされた場合は再帰しない
    if (isUnmounted.value) {
      return
    }
    imgSrc.value = res.data.data.url
    timer.value = setTimeout(getLiveImg, 60 * 1000)
  } catch (e) {
    requestError.value = true
  } finally {
    isLoaded.value = true
  }
}

const clearTimer = () => {
  if (timer.value !== null) {
    clearTimeout(timer.value)
    timer.value = null
  }
}

apiPath.value = API.START_LIVE.replace('{camera_code}', props.cameraDetail.camera_code)
getLiveImg()

return (_ctx: any,_cache: any) => {
  return (!requestError.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Thumbnail), {
          src: imgSrc.value,
          "use-lazy-load": false,
          width: `${__props.displaySize.width}px`
        }, null, 8, ["src", "width"]),
        (!isLoaded.value)
          ? (_openBlock(), _createBlock(_unref(Spinner), {
              key: 0,
              class: "spinner"
            }))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('live.cannot_live')), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('live.please_contact')), 1)
      ]))
}
}

})